import * as s from "@/lib/styles";

/** The sign-in family of pages (sign in, forgot, reset), built for a phone:
 *  labels above the fields, 16px text so iOS doesn't zoom in on focus, and a
 *  full-width button for a thumb. Wider screens keep the side-by-side form. */
export const authPage = "flex min-h-[calc(100dvh-100px)] justify-center px-4 pt-[10vh] sm:items-center sm:pt-0";
export const authCard = s.card + " !space-y-4 !p-4 sm:!space-y-2 sm:!p-3";
export const authRow = "flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-2";
export const authLabel = "text-sm font-medium text-amber sm:w-36 sm:shrink-0";
export const authInput = s.input + " !py-2 !text-base sm:!py-[3px] sm:!text-sm";
export const authButton = s.btnPrimary + " w-full !py-2.5 !text-base sm:w-auto sm:!py-1 sm:!text-sm";
